module.exports = __webpack_public_path__ + "static/num_of_participants@1x-85c3e36903654ba4b43f1b8d6eda9453.png";